import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';
import { CommonUtil } from '../../../core/Utils/common-util';
import { environment } from '../../../../environments/environment';
import { IHeatMapDash } from '../../../core/services/facility.model';

@Component({
  selector: 'app-facility-success-modal',
  templateUrl: './facility-success-modal.component.html',
  styleUrls: ['./facility-success-modal.component.scss']
})
export class FacilitySuccessModalComponent implements OnInit {
  rootScopeData: RootScopeDeclare;
  cloudBasePath: string;
  @Output() callOnBtnClick: EventEmitter<string> = new EventEmitter();

  constructor(private rootScopeService: RootScopeService, private commonUtil: CommonUtil) { }

  getRootScopeData(): void {
    this.rootScopeData = this.commonUtil.rootScopeData;
  }

  ngOnInit(): void {
    this.cloudBasePath = environment.cloudBasePath;
    this.getRootScopeData();
  }
  onNegativeButtonClick(): void {
    this.callOnBtnClick.emit();
  }

  onPositiveButtonClick(): void {
    this.callOnBtnClick.emit();
  }

  stopBubbling(e: Event) {
    e.stopPropagation();
  }

}
